<div class="config-panel">

    <!-- HEADER -->
    <div class="config-header">

        <div class="config-header-icon">
            <i class="fa-solid fa-gear"></i>
        </div>

        <div>
            <h2 class="config-title">
                {{ title }}
            </h2>

            <p class="config-description" *ngIf="description">
                {{ description }}
            </p>
        </div>

    </div>


    <!-- CONTENIDO -->
    <div class="config-content">

        <!-- SIDEBAR -->
        <aside class="config-sidebar">

            <div class="sidebar-title">
                CONFIGURACIÓN
            </div>

            <nav class="config-nav">

                <button type="button" class="config-nav-item" *ngFor="let tab of tabs" [class.active]="isActive(tab)"
                    [class.disabled]="tab.disabled" [disabled]="tab.disabled" (click)="selectTab(tab)">

                    <span class="nav-icon">
                        <i [class]="tab.icon"></i>
                    </span>

                    <span class="nav-label">
                        {{ tab.label }}
                    </span>

                    <span *ngIf="tab.badge" class="nav-badge">

                        {{ tab.badge }}

                    </span>

                </button>

            </nav>

        </aside>


        <!-- PANEL DERECHO -->
        <main class="config-main">

            <ng-content></ng-content>

        </main>

    </div>

</div>